import { createContext, useMemo } from 'react';
import PropTypes from 'prop-types';

export const DataGridContext = createContext({ type: 'body' });

export default function DataGridContextProvider({ type, children }) {
  const contextValue = useMemo(() => ({ type }), [type]);

  return (
    <DataGridContext.Provider value={contextValue}>
      {children}
    </DataGridContext.Provider>
  );
}

DataGridContextProvider.propTypes = {
  type: PropTypes.oneOf(['header', 'body', 'footer']),
  children: PropTypes.node,
};
